/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const generateChallengeBodySchema = z.object({
  targetContent: z.string().min(1),
});

export type IGenerateChallengeBody = z.infer<typeof generateChallengeBodySchema>;
